import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import { useSnackbar } from 'notistack';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import logOut from '@iconify/icons-eva/log-out-fill';
import { useHistory } from 'react-router-dom';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, AppBar, Hidden, Toolbar, IconButton } from '@material-ui/core';
import { UtilsLib } from '@payface-frontends-libs/utils';
import { logout } from '../../authentication/services';
const { useIsMountedRef } = UtilsLib.Hooks;
const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;
const RootStyle = styled(AppBar)(({ theme }) => ({
    boxShadow: 'none',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)',
    backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up('lg')]: {
        width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
    },
}));
const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
    minHeight: APPBAR_MOBILE,
    [theme.breakpoints.up('lg')]: {
        minHeight: APPBAR_DESKTOP,
        padding: theme.spacing(0, 5),
    },
}));
export function DashboardNavbar({ onOpenSidebar }) {
    const history = useHistory();
    const isMountedRef = useIsMountedRef();
    const { enqueueSnackbar } = useSnackbar();
    const handleLogout = async () => {
        try {
            logout();
            if (isMountedRef.current) {
                history.push('/');
            }
        }
        catch (error) {
            enqueueSnackbar('Erro ao sair da conta', { variant: 'error' });
        }
    };
    return (_jsx(RootStyle, { children: _jsxs(ToolbarStyle, { children: [_jsx(Hidden, Object.assign({ lgUp: true }, { children: _jsx(IconButton, Object.assign({ onClick: onOpenSidebar, sx: { mr: 1, color: 'text.primary' } }, { children: _jsx(Icon, { icon: menu2Fill }, void 0) }), void 0) }), void 0), _jsx(Box, { sx: { flexGrow: 1 } }, void 0), _jsx(Box, Object.assign({ sx: {
                        display: 'flex',
                        alignItems: 'center',
                        '& > *:not(:first-of-type)': {
                            ml: { xs: 1.5, sm: 2, lg: 3 },
                        },
                    } }, { children: _jsx(IconButton, Object.assign({ onClick: handleLogout, sx: { mr: 1, color: 'text.primary' } }, { children: _jsx(Icon, { icon: logOut }, void 0) }), void 0) }), void 0)] }, void 0) }, void 0));
}
//# sourceMappingURL=DashboardNavbar.js.map